import React, { useMemo } from "react";
import { ChevronLeft } from "../../Icons/IconPackage/ChevronLeft";
import { ChevronRight } from "../../Icons/IconPackage/ChevronRight";
import './style.scss';

const getDisplayPages = (pages, page) => {
    let result = Array.from({ length: pages }, (_, i) => i);
    if (pages > 5) {
        let range = [page - 2, page + 2];
        while (range[0] < 0) {
            range = range.map(i => i + 1)
        }
        while (range[1] >= pages) {
            range = range.map(i => i - 1)
        }
        result = result.slice(range[0], range[1] + 1)
    }
    return result;
}

const CPaginator = ({ currentPage, perPage, total, onChangePage }) => {
    const pages = Number.isFinite(total / perPage) ? Math.ceil(total / perPage) : 1;
    const displayPages = useMemo(() => getDisplayPages(pages, currentPage), [pages, currentPage]);

    const moveBackDisabled = currentPage === 0;
    const moveForwardDisabled = currentPage === pages - 1;

    return <div className="c-paginator">
        <button className="c-paginator-button" disabled={moveBackDisabled} onClick={() => onChangePage(0)}>
            <ChevronLeft />
            <ChevronLeft style={{ marginLeft: -8 }} />
        </button>
        <button className="c-paginator-button" disabled={moveBackDisabled} onClick={() => onChangePage(currentPage - 1)}>
            <ChevronLeft />
        </button>
        {displayPages.map((_page) => <button
            key={_page}
            onClick={() => onChangePage(_page)}
            className={`c-paginator-button ${_page === currentPage ? 'active' : ''}`}
        >
            {_page + 1}
        </button>)}
        <button className="c-paginator-button" disabled={moveForwardDisabled} onClick={() => onChangePage(currentPage + 1)}>
            <ChevronRight />
        </button>
        <button className="c-paginator-button" disabled={moveForwardDisabled} onClick={() => onChangePage(pages - 1)}>
            <ChevronRight />
            <ChevronRight style={{ marginLeft: -8 }} />
        </button>
    </div>
}

export default CPaginator;